import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "dec-use-flex" }
const _hoisted_2 = { class: "context" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "select-engine" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createElementVNode("span", null, [
            /*#__PURE__*/_createElementVNode("span", null, "3.1 Select Engine")
          ])
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "（选择引擎）")
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Select the starting virtual engine version (currently only supports UE4) and select the program/project file to be opened.")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "When the setting is completed, open & load the virtual engine and open the program.")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "material" }, [
    /*#__PURE__*/_createElementVNode("span", null, "3.2 Material")
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Function introduction: MAYA material browser.")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "（1）Select the model, double-click the selected material, and render the corresponding material to the model.")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "（2）Within the extended properties of the Shading Group node, you can see the properties of the material instantiated by the UE (this function is consistent with the usage habits of the MAYA.)")
], -1)
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<h2><a id=\"lecel-map\"><span><span><span><span><span>3.3LeveI Map</span></span></span></span></span></a></h2><p><span>*</span><span>This function is for the Pro Edition.</span></p><p><span>(1)<span>  </span></span><span>The DEC can save the Level Map in the MAYA scene. In this way, when you open the MAYA scene the next time, you can find the corresponding Level Map of the last time.</span></p><p><span>(2)<span>  </span></span><span>Click &quot;Level Map&quot; to open the Level Map panel.</span></p>", 4)
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<p><span>（3）In the Level Map panel:</span></p><p><span>① The Saved Level Map information box displays the relative path of the saved Level Map.</span></p><p><span>② The Current Level Map information box displays the relative path of the currently connected Level Map.</span></p><p><span>③ “Refresh” means refreshing the relative path of the currently connected Level Map to the Current Level Map information box.</span></p><p><span>④ “Save” means saving the relative path of the currently connected Level Map in the Saved Level Map information box on the premise that the path has been displayed in the Current Level Map information box.</span></p><p><span>⑤ “Load” means loading the Level Map in the Current Level Map information box by the UE.</span></p><p></p><h2><a id=\"render-settings\"><span>3.4 Render Settings</span></a></h2><p><span>Function introduction: The DEC Render is a tool for rendering the output, allowing the MAYA to set rendering parameters and output as easily as the UE.</span></p><p><span>（1）Rendering the video setting panel.</span></p>", 10)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "(1) You can set the image output format in Section 1. If you modify the resolution of the rendered video, you need to set the resolution of MAYA's output first.")
], -1)
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<p><span>(2) You can start the UE default compression in Section 2.</span></p><p><span>(3) You can set the video output directory in Section 3.</span></p><p><span>(4) You can set the cutscenes in Section 4</span></p><p><span>(5) You can set the sequence in Section 5.</span></p><p><span>(6) After setting, click Save to save the settings.</span></p><h2><a id=\"render-range\"><span>3.5 Render range</span></a></h2><p><span>Function introduction: Setting Start Frame and End Frame for Animation</span></p>", 7)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "render" }, [
    /*#__PURE__*/_createElementVNode("span", null, "3.6 Render")
  ])
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "After being clicked, it will render the video with the parameters you set in the Render Settings panel.")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "movie-render" }, [
    /*#__PURE__*/_createElementVNode("span", null, "3.7 Movie Render Queue")
  ])
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Function introduction: An upgraded version of Render, which can render high-quality textures in a better way.")
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, " （1）Render（Local） ")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "After being clicked, it will render the video with the parameters you set in the Render Queue Settings panel.")
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, " （2）Render Queue Setting")
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "①After clicking, the render Queue settings panel will appear.")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "②You can add the level sequence by clicking Render in the upper left corner. After adding, you can set the rendering perimeter by clicking Unsaved Config under Settings.")
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "③The rendering parameters only show the basic parameters initially, and you can add the corresponding parameters you need to adjust by clicking Settings in the upper left corner.")
], -1)
const _hoisted_43 = /*#__PURE__*/_createStaticVNode("<p><span>④ After setting, the parameters on the panel can be applied to the corresponding level sequence by clicking Accept.</span></p><p><span>⑤You can also load preset parameters or save the parameters on the panel as preset parameters to the resource manager by clicking Load/Save Preset in the upper right corner.</span></p><h2><a id=\"set-camera\"><span>3.8 Set Camera</span></a></h2><p><span>Function introduction: It adjusts the current viewing angle of MAYA to the current viewing angle of UE.</span></p><h2><a id=\"export-scene\"><span>3.9 Export Scene</span></a></h2><p><span>Function introduction: It exports scenes and materials from MAYA to the UE.</span></p><p><span>（1）Click the Export Scene, and the pop-up window for selecting the storage address will appear. In the pop-up window, you can select the path you want to save and set the corresponding asset name for it.</span></p>", 7)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "You can set the storage folder in Section 1.")
], -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "You can edit the name of the asset in Section 2.")
], -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "After setting, click Confirm to save the settings.")
], -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "（2）There are no light nodes in the exported scene, you need to create light nodes in the scene yourself (If the exported model is too small, it will not be able to cast shadows in the UE).")
], -1)
const _hoisted_54 = /*#__PURE__*/_createStaticVNode("<h2><a id=\"mesh-streaming\"><span>3.10 Use Cached GeometryExtractor</span></a></h2><p><span>Function introduction: It cache Maya&#39;s geometry information extraction to improve computer performance.</span></p><p><span>(1) Selecting On (faster) DEC will cache the geometric information in MAYA when extracting it, but in some cases the model will be out of sync.</span></p><p><span>(2) Selecting Off (default) It will turn off the cache function.</span></p><h2><a id=\"add-engine-asset\"><span>3.11 Delay Render</span></a></h2><p><span>Function introduction: The DEC optimizes the algorithm strategy, improving the user experience and performance.</span></p><p><span>(1) Selecting On (faster) speeds up the rendering process, but at the same time, it reduces the quality of the rendering effect, selecting Off (default) to turn off the acceleration service. On (most faster) With Wireframe Lagged improves performance better, but the model will be one frame behind the wireframe.</span></p><h2><a id=\"normal-tangent\"><span>3.12 Normal Tangent Streaming</span></a></h2><p><span>Function introduction: The switch for normal and tangent streaming information transmission, which can be enabled or disabled when needed.</span></p><p><span>(1) Selecting On (default) DEC will transfer the model&#39;s normal and tangent streaming information to Unreal Engine.</span></p><p><span>(2) Selecting Off (faster) DEC will turn off normal and tangent streaming information transmission to improve performance.</span></p><h2><a id=\"add-engine-transform\"><span>3.13 Add Engine Transform Delegate</span></a></h2><p><span>*</span><span>This function is for the Trial Version.</span></p><p><span>Function introduction: With it, you can perform the UE assets&#39; translation, zoom, and rotation in the MAYA.</span></p><p><span>After creating and selecting a Locator in MAYA, then click the Add Engine Transform Delegate, and you will create an Actor with the name of Engine Transform Actor inside the UE.</span></p>", 15)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "（2）Components can be created within the corresponding Actor, and the components within the corresponding Actor can perform displacement, rotation and zooming at any Transform node in the MAYA.")
], -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "manage-engine-transform" }, [
    /*#__PURE__*/_createElementVNode("span", null, "3.14 Manage Engine Transform Delegate")
  ])
], -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Function introduction: It is the window of the Engine Transform View. ")
], -1)
const _hoisted_72 = /*#__PURE__*/_createStaticVNode("<p><b><span>Transform Delegate List</span></b></p><p><span>It displays the UE assets created through the Create Engine Asset Node and the Create Engine Transform Delegate in the MAYA.</span></p><p><b><span>MAYA Model List</span></b></p><p><span>It displays all objects in the MAYA scene.</span></p><h2><a id=\"create-engine-node\"><span>3.15 Create Engine Asset Node</span></a></h2><p><span>*</span><span>This function is for the Pro Edition.</span></p><p><span>Function introduction: You can add the assets inside the virtual engine to the MAYA.</span></p><p><span>（1）After clicking, the asset selection window will appear.</span></p>", 8)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "①You can select the asset folder in Section 1.")
], -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "②The assets in the folder can be displayed in Section 2. Double-click the asset to add the corresponding asset to the MAYA scene.")
], -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "After adding the assets, you can set the basic properties of the corresponding assets inside the virtual engine in the MAYA.")
], -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "set-asset-path" }, [
    /*#__PURE__*/_createElementVNode("span", null, "3.16 Set Engine Asset Path")
  ])
], -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Function introduction: Used to modify the engine node created by Create Engine Asset Node.")
], -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "about" }, [
    /*#__PURE__*/_createElementVNode("span", null, "3.17 About Us")
  ])
], -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Function introduction: It is the introduction of the DEC software.")
], -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "dec-use-maya" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createElementVNode("span", null, [
            /*#__PURE__*/_createElementVNode("span", null, "3.18 DEC supports MAYA+UE version")
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_88 = { class: "name" }
const _hoisted_89 = { class: "version" }
const _hoisted_90 = { class: "version" }
const _hoisted_91 = { class: "version" }
const _hoisted_92 = { class: "version" }
const _hoisted_93 = { class: "version" }


export default /*#__PURE__*/_defineComponent({
  __name: 'DecUseEn',
  setup(__props) {

const versionData = [
  {
    name: "MAYA：",
    version1: "2017",
    version2: "2018",
    version3: "2019",
    version4: "2020",
    version5: "2022",
    version5: "2023",
  },
  {
    name: "UE：",
    version1: "4.26",
    version2: "4.27",
    version3: "5.0",
    version4: "",
    version5: "",
  },
];
const imageList = {
  image1: require("../../assets/en-document-images/bdf3873b77b84aaf932d22fd54e4dfaf.jpg"),
  image2: require("../../assets/en-document-images/2fd8f307aae343ee83655bd60995fcc0.png"),
  image3: require("../../assets/en-document-images/14d428947f7649e1897ff35be8dec17d.jpg"),
  image4: require("../../assets/en-document-images/882e194154f84ef5a5e4ffa37fde36ea.jpg"),
  image5: require("../../assets/en-document-images/531fa6820e90460b9f82e84c7f20d6e4.jpg"),
  image6: require("../../assets/document-images/3-4-1.png"),
  image7: require("../../assets/document-images/3-5-1.png"),
  image3_7: require("../../assets/document-images/3-7-1.png"),
  image3_7_2: require("../../assets/document-images/3-7-2.png"),
  image3_7_3: require("../../assets/document-images/3-7-3.png"),
  image3_7_4: require("../../assets/document-images/3-7-4.png"),
  image8: require("../../assets/en-document-images/c7ebf6134dd64784a359ab7e2e70875c.jpg"),
  image9: require("../../assets/en-document-images/2586d470cff7498b8127a827162ffbab.png"),
  image10: require("../../assets/en-document-images/d089e3a510bc4d38aa1e7613a6d10d32.jpg"),
  image11: require("../../assets/en-document-images/015424af979845229cdcf29bebc00333.jpg"),
  image12: require("../../assets/en-document-images/b3625935edff4a4f877da8e1e2044a53.jpg"),
  image13: require("../../assets/en-document-images/f72459a2626c4809a5753178369e6bb0.jpg"),
  image14: require("../../assets/en-document-images/18741ba498694afaa721aeddf5ee7d40.jpg"),
  image15: require("../../assets/en-document-images/4d4c0563e9944b14b228d571460ff71e.jpg"),
  image16: require("../../assets/en-document-images/2f7f9d24f2c443e99d5a9dd4e78e185b.png"),
  image17: require("../../assets/en-document-images/68b8369b7c9e48148befc1d702d3390a.jpg"),
};

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _hoisted_4,
          _createElementVNode("span", null, [
            _createVNode(_component_el_image, {
              src: imageList.image1,
              "preview-src-list": [imageList.image1],
              fit: "contain"
            }, null, 8, ["src", "preview-src-list"])
          ])
        ])
      ]),
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image2,
          "preview-src-list": [imageList.image2],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_10,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image3,
          "preview-src-list": [imageList.image3],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_11,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image4,
          "preview-src-list": [imageList.image4],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_15,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image5,
          "preview-src-list": [imageList.image5],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_25,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image6,
          "preview-src-list": [imageList.image6],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_26,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image7,
          "preview-src-list": [imageList.image7],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_33,
      _hoisted_34,
      _hoisted_35,
      _hoisted_36,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image3_7,
          "preview-src-list": [imageList.image3_7],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_37,
      _hoisted_38,
      _hoisted_39,
      _hoisted_40,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image3_7_2,
          "preview-src-list": [imageList.image3_7_2],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_41,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image3_7_3,
          "preview-src-list": [imageList.image3_7_3],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_42,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image3_7_4,
          "preview-src-list": [imageList.image3_7_4],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_43,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image9,
          "preview-src-list": [imageList.image9],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_50,
      _hoisted_51,
      _hoisted_52,
      _hoisted_53,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image10,
          "preview-src-list": [imageList.image10],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_54,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image14,
          "preview-src-list": [imageList.image14],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image15,
          "preview-src-list": [imageList.image15],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_69,
      _hoisted_70,
      _hoisted_71,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image16,
          "preview-src-list": [imageList.image16],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_72,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image12,
          "preview-src-list": [imageList.image12],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_80,
      _hoisted_81,
      _hoisted_82,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image13,
          "preview-src-list": [imageList.image13],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_83,
      _hoisted_84,
      _hoisted_85,
      _hoisted_86,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image17,
          "preview-src-list": [imageList.image17],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_87,
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(versionData, (item) => {
        return _createElementVNode("div", {
          key: item.name,
          class: "version-flex"
        }, [
          _createElementVNode("span", _hoisted_88, _toDisplayString(item.name), 1),
          _createElementVNode("span", _hoisted_89, _toDisplayString(item.version1), 1),
          _createElementVNode("span", _hoisted_90, _toDisplayString(item.version2), 1),
          _createElementVNode("span", _hoisted_91, _toDisplayString(item.version3), 1),
          _createElementVNode("span", _hoisted_92, _toDisplayString(item.version4), 1),
          _createElementVNode("span", _hoisted_93, _toDisplayString(item.version5), 1)
        ])
      }), 64))
    ])
  ]))
}
}

})